import { DEFAULT_IMAGE, RESIZER_PROXY } from "../globals";

export function imageResizer(url = DEFAULT_IMAGE, width = 960, height = null) {
  let resizerUrl = `${RESIZER_PROXY}?src=${encodeURIComponent(url)}&w=${width}`;

  if (height) {
    resizerUrl += `&h=${height}`;
  }

  return resizerUrl;
}

export const getStreamsByTypeAndBitrate = (
  streams,
  stream_type,
  maxBitrate
) => {
  return streams
    .filter(
      stream =>
        stream["bitrate"] <= maxBitrate && stream["stream_type"] === stream_type
    )
    .reduce((prev, current) => {
      return prev?.bitrate > current?.bitrate ? prev : current;
    }, undefined);
};

/**
 * Returns the maximum bitrate for a given device type
 * @param {array} streams of possile streams
 * @returns  the stream that matches the device type
 */
export const getVideoStream = streams => {
  // let hls handle level selection based on device bandwidth
  // capLevelToPlayerSize is set to true in useHls and should prevent mobile devices from receiving bitrates that are too high
  return streams
    .filter(
      stream =>
        (stream.stream_type === "ts") &
        !stream.url?.endsWith("hlsv4_master.m3u8")
    )
    .reduce((prev, current) => {
      return prev?.bitrate > current?.bitrate ? prev : current;
    }, undefined);
};

export const getVideoStreamForVerticalVideoThumbnail = streams => {
  return getStreamsByTypeAndBitrate(streams, "mp4", 600) || streams?.[0];
};

/**
 * Add leading digits to a number until it has at least 2 digits
 * @param {number} num the number to pad
 * @returns {string} padded number (with leading zeroes)
 */
function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
}

/**
 * Given a duration in milliseconds, convert it to hh:mm:ss format
 * @param {number} milliseconds time in milliseconds
 * @returns {object} contains 2 properties:
 * visible: the milliseconds formatted as hh:mm:ss (or mm:ss if hours is 0)
 * srOnly: the milliseconds formatted as "X hours, Y minutes and Z seconds"
 * (or Y minutes and Z seconds, if hours is 0) for screen readers
 */
export function formatHoursMinutesSeconds(milliseconds) {
  if (!milliseconds) {
    return { visible: "", srOnly: "" };
  }

  let seconds = Math.floor(milliseconds / 1000);
  let minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  seconds %= 60;
  minutes %= 60;

  const visibleFormat = hours
    ? `${hours}:${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`
    : `${minutes}:${padTo2Digits(seconds)}`;

  const screenReaderFormat = hours
    ? `${hours} hours, ${padTo2Digits(minutes)} minutes and ${padTo2Digits(
        seconds
      )} seconds`
    : `${minutes} minutes and ${padTo2Digits(seconds)} seconds`;

  return { visible: visibleFormat, srOnly: screenReaderFormat };
}
